import React from "react";

import { type SxProps } from "@mui/material";

import useResponsiveView from "@app/common/hooks/useResponsiveView";

import { Container } from "./styles";
import UpsellModuleAccordion from "./UpsellModuleAccordion";
import UpsellModuleActions, {
  UpsellModuleActionsProps,
} from "./UpsellModuleActions";
import UpsellModuleInnerContent, {
  UpsellModuleInnerContentProps,
} from "./UpsellModuleInnerContent";

export interface UpsellModuleProps {
  /* Base color for the background circles */
  color?: React.CSSProperties["color"];
  img?: UpsellModuleInnerContentProps["img"];
  cta?: UpsellModuleActionsProps["cta"];
  onDismiss?: UpsellModuleActionsProps["onDismiss"];
  sx?: SxProps;
  title?: React.ReactNode;
  content?: React.ReactNode;
}

const UpsellModule = ({
  cta,
  img,
  color,
  onDismiss,
  sx,
  title,
  content,
}: UpsellModuleProps) => {
  const { inDesktopView } = useResponsiveView();

  const actions = <UpsellModuleActions cta={cta} onDismiss={onDismiss} />;
  return (
    <Container sx={sx} color={color}>
      {inDesktopView ? (
        <>
          <UpsellModuleInnerContent img={img}>
            {title}
            {content}
          </UpsellModuleInnerContent>
          {actions}
        </>
      ) : (
        <UpsellModuleAccordion
          img={img}
          title={title}
          content={content}
          actions={actions}
        />
      )}
    </Container>
  );
};

export default UpsellModule;
